

export class CheckboxRenderer {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-checkbox');
    this.input.checked = this.params.data.enabled;
    this.input.value = this.params.data.feature;
    this.input.label = this.params.data.feature;
    this.input.addEventListener('i2c-change', (event) => {
      this.params.data.enabled = event.target.checked;
      params.context.methods.setValue(`card_enrollment_shipping_method[${params.rowIndex}].feature`, event.target.label);
      params.context.methods.setValue(`card_enrollment_shipping_method[${params.rowIndex}].enabled`, event.target.checked);
      params.context.methods.trigger();
      params.context.handleValueChanges();
      params.api.refreshCells({ force: true });
    });
    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.checked = this.params.data.enabled;
    return true;
  }
}
export class InputRenderer {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-input');
    this.input.type = 'text';
    this.input.value = params.data.alternativeMethod;
    this.input.disabled = !params.data.enabled;
    this.input.addEventListener('i2c-change', (event) => {
      this.params.data.alternativeMethod = event.target.value;
      params.context.methods.setValue(`card_enrollment_shipping_method[${params.rowIndex}].alternativeMethod`, event.target.value);
      params.context.methods.trigger();
      params.context.handleValueChanges();
    });
    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.value = this.params.data.alternativeMethod;
    this.input.disabled = !this.params.data.enabled;
    return true;
  }
}
export class CheckboxTableRenderer {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-checkbox');
    this.input.checked = this.params.value;
    this.input.label = "";
    const isDisabled = this.params.data.disabled;
    this.input.disabled = isDisabled;

    this.input.addEventListener('i2c-change', (event) => {
      if (isDisabled) return;

      const { rowIndex, colDef } = this.params;
      const fieldName = colDef.field;
      const feature = this.params.data.enrollment_field;
      this.params.data[fieldName] = event.target.checked;

      params.context.methods.setValue(`${this.params.context.tableType}[${rowIndex}].${fieldName}`, event.target.checked);
      params.context.methods.setValue(`${this.params.context.tableType}[${rowIndex}].enrollment_field`, feature);

      params.context.methods.trigger();
      params.context.handleValueChanges();
      params.api.refreshCells({ force: true });
    });

    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.checked = this.params.value;

    const isDisabled = this.params.data.disabled;
    this.input.disabled = isDisabled;

    return true;
  }
}
export class HeaderCheckboxRenderer {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-checkbox');
    this.input.checked = false;
    this.input.label = this.params.displayName;

    this.input.addEventListener('i2c-change', (event) => {
      const checked = event.target.checked;
      const column = this.params.column.getColId();

      this.params.api.forEachNode((node) => {
        if (node.data.disabled) return;
        node.data[column] = checked;
        const rowIndex = node.rowIndex;
        this.params.context.methods.setValue(`${this.params.context.tableType}[${rowIndex}].${column}`, checked);
        this.params.context.methods.setValue(`${this.params.context.tableType}[${rowIndex}].enrollment_field`, node.data.enrollment_field);
      });

      this.params.context.methods.trigger();
      this.params.context.handleValueChanges();
      this.params.api.refreshCells({ force: true });
    });

    this.eGui = document.createElement('div');
    this.eGui.appendChild(this.input);

    this.updateHeaderCheckboxState();
  }

  getGui() {
    return this.eGui;
  }

  updateHeaderCheckboxState() {
    const column = this.params.column.getColId();
    let allChecked = false;

    this.params.api.forEachNode((node) => {
      if (!node.data.disabled && node.data[column] !== true) {
        allChecked = false;
      }
    });

    this.input.checked = allChecked;
  }

  refresh(params) {
    this.params = params;
    this.updateHeaderCheckboxState();
    return true;
  }
}

export class EnrollmentFieldRenderer {
  init(params) {
    this.params = params;
    this.eGui = document.createElement('div');
    this.eGui.className= "flex-table-cell"

    const fieldName = document.createElement('span');
    fieldName.innerText = this.params.value;
    this.eGui.appendChild(fieldName);

    if (this.params.data.deleteable) {
      const deleteIcon = document.createElement('i2c-icon-button');  
      deleteIcon.name = 'linear-trash';  
      deleteIcon.label = 'Edit';  
      deleteIcon.style.cursor = 'pointer';

      deleteIcon.style.marginLeft = '40px';
      deleteIcon.addEventListener('click', () => {
        const rowIndex = this.params.node.rowIndex;
        const updatedData = this.params.api.getDisplayedRowAtIndex(rowIndex).data;
        const newData = this.params.api.rowModel.rowsToDisplay
          .map(row => row.data)
          .filter((_, index) => index !== rowIndex);
        this.params.context.methods.setValue(this.params.context.tableType, newData);
        this.params.context.methods.trigger();
        this.params.context.handleValueChanges();

        this.params.api.setRowData(newData);
      });

      this.eGui.appendChild(deleteIcon);
    }
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    return true;
  }
}